import React, { useState } from 'react'

import { API_URL } from '@configs/config'
import { useAuthentication } from '@hooks/useAuthentication'
import { useAlert } from '@hooks/useAlert'
import { useModal } from '@hooks/contexts/ModalContext/ModalContext'
import { ExportButtonProps, WithExportButtonProps } from './interface'

export function withExportButton(Component: React.FC<ExportButtonProps>) {
  function WithExportButton({ queryParams, tabId }: WithExportButtonProps) {
    const [isLoading, setLoading] = useState(false)
    const [isOpenConfirmModal, setOpenConfirmModal] = useState(false)
    const { token } = useAuthentication()
    const alert = useAlert()
    const confirmModal = useModal(
      {
        modal: 'confirm',
      },
      true
    )

    function closeConfirmModal() {
      setOpenConfirmModal(false)
    }

    function mapFileName() {
      let fileName = ''
      if (tabId === 'overview') {
        fileName = queryParams.bookId
          ? 'writer_pages_id.xlsx'
          : 'writer_pages_overview.xlsx'
      } else {
        fileName = queryParams.ebookId
          ? 'writer_ebook_id.xlsx'
          : 'writer_ebook_overview.xlsx'
      }
      return fileName
    }

    async function exportFile() {
      const { days } = queryParams.endDate.diff(queryParams.startDate, ['days'])
      if (days > 30) {
        setOpenConfirmModal(true)
      } else {
        setLoading(true)
        const apiUrl = API_URL.replace('/graphql', '')
        let url = `${apiUrl}`
        if (tabId === 'overview') {
          url += `/export-data-client/writer-overview`
        } else if (tabId === 'ebook' && queryParams.ebookId) {
          url += `/export-data-client/writer-dashboard-ebook-by-id`
        } else {
          url += `/export-data-client/writer-dashboard-ebook-overview`
        }

        url += `?startDate=${queryParams.startDate.toUTC()}&endDate=${queryParams.endDate.toUTC()}`

        if (queryParams.penNameIds?.length)
          url += `&penNameIds=${queryParams.penNameIds}`
        if (queryParams.categoryIds?.length)
          url += `&categoryIds=${queryParams.categoryIds}`
        if (tabId !== 'ebook' && queryParams.bookTypes?.length)
          url += `&bookTypes=${queryParams.bookTypes.map(row =>
            row.toLowerCase()
          )}`
        if (tabId === 'ebook' && queryParams.bookTypes?.length)
          url += `&ebookTypes=${queryParams.bookTypes.map(row =>
            row.toLowerCase()
          )}`
        if (queryParams.ebookId) url += `&ebookId=${queryParams.ebookId}`
        if (queryParams.bookId) url += `&bookId=${queryParams.bookId}`

        const response = await fetch(url, {
          method: 'GET',
          headers: { Authorization: `Bearer ${token}` },
        })

        if (response.status === 200) {
          const blob = await response.blob()
          const fileUrl = URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.style.display = 'none'
          a.href = fileUrl
          a.download = mapFileName()
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          URL.revokeObjectURL(fileUrl)
        } else {
          alert.error('เกิดข้อผิดพลาดไม่สามารถดาวน์โหลดเอกสารได้')
        }
        setLoading(false)
      }
    }

    return (
      <Component
        isLoading={isLoading}
        isOpenConfirmModal={isOpenConfirmModal}
        exportFile={exportFile}
        closeConfirmModal={closeConfirmModal}
      />
    )
  }

  return WithExportButton
}
